import React, { forwardRef, useEffect, useState } from "react";

const TenderPrint = forwardRef(({ data: propData }, ref) => {
  const [data, setData] = useState({ items: [] });

  useEffect(() => {
    setData(propData || { items: [] });
  }, [propData]);

  const styles = {
    container: { fontFamily: "Arial", fontSize: "13px", margin: "20px" },
    h2: { textAlign: "center", textTransform: "uppercase", margin: "5px 0" },
    table: { width: "100%", borderCollapse: "collapse", marginBottom: "12px" },
    th: {
      border: "1px solid #000",
      padding: "5px",
      backgroundColor: "#f2f2f2",
      fontWeight: "bold",
    },
    td: { border: "1px solid #000", padding: "5px" },
    sectionTitle: {
      backgroundColor: "#ddd",
      fontWeight: "bold",
      padding: "6px",
      margin: "12px 0 6px",
    },
    textRight: { textAlign: "right" },
    textCenter: { textAlign: "center" },
  };

  const totals = (data.items || []).reduce(
    (acc, item) => {
      const qty = Number(item.purchaseQuantity || 0);
      const price = Number(item.orderPriceUnit || 0);
      const net = qty * price;

      acc.totalQty += qty;
      acc.totalValue += net;

      return acc;
    },
    { totalQty: 0, totalValue: 0 }
  );

  return (
    <div ref={ref} className="m-4">
      <div style={styles.container}>
        <h2 style={styles.h2}>Byyizzy Tender</h2>

        {/* Tender Details */}
        <div style={styles.sectionTitle}>Tender Details</div>
        <table style={styles.table}>
          <tbody>
            <tr>
              <td style={styles.td}>
                <strong>Tender No:</strong> {data.documentNumber || "-"}
              </td>
              <td style={styles.td}>
                <strong>Status:</strong> {data.transaction || "-"}
              </td>
            </tr>
            <tr>
              <td style={styles.td} colSpan={2}>
                <strong>Tender Title:</strong> {data.tenderTitle || "-"}
              </td>
            </tr>
            <tr>
              <td style={styles.td}>
                <strong>Category:</strong> {data.category || "-"}
              </td>
              <td style={styles.td}>
                <strong>Priority:</strong> {data.priority || "-"}
              </td>
            </tr>
            <tr>
              <td style={styles.td}>
                <strong>Opening Date:</strong>{" "}
                {data.openingDateTime || "-"}
              </td>
              <td style={styles.td}>
                <strong>Closing Date:</strong>{" "}
                {data.closingDateTime || "-"}
              </td>
            </tr>
          </tbody>
        </table>
        <div style={styles.sectionTitle}>Tender Line Items</div>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>S.No</th>
              <th style={styles.th}>Material Code</th>
              <th style={styles.th}>Description</th>
              <th style={styles.th}>Qty</th>
              <th style={styles.th}>UOM</th>
              {/* <th style={styles.th}>Estimated Unit Price</th> */}
              {/* <th style={styles.th}>Estimated Value</th> */}
              <th style={styles.th}>Delivery Date</th>
            </tr>
          </thead>
          <tbody>
            {data.items?.length ? (
              data.items.map((item, idx) => (
                <tr key={idx}>
                  <td style={styles.td}>{idx + 1}</td>
                  <td style={styles.td}>{item.materialCode}</td>
                  <td style={styles.td}>{item.materialDescription}</td>
                  <td style={styles.td}>{item.purchaseQuantity}</td>
                  <td style={styles.td}>{item.orderUnitOfMeasure}</td>
                  {/* <td style={{ ...styles.td, ...styles.textRight }}>
                    {item.orderPriceUnit}
                  </td>
                  <td style={{ ...styles.td, ...styles.textRight }}>
                    {item.purchaseQuantity * item.orderPriceUnit}
                  </td> */}
                  <td style={styles.td}>{item.deliveryDate}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={8} style={{ ...styles.td, textAlign: "center" }}>
                  No line items available
                </td>
              </tr>
            )}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={3} style={styles.td}>
                <strong>Total</strong>
              </td>
              <td style={styles.td}>{totals.totalQty}</td>
              <td style={styles.td}></td>
              <td style={styles.td}></td>
              <td style={{ ...styles.td, ...styles.textRight }}>
                {totals.totalValue}
              </td>
              <td style={styles.td}></td>
            </tr>
          </tfoot>
        </table>

        {/* Summary */}
        <div style={styles.sectionTitle}>Summary</div>
        <table style={styles.table}>
          <tbody>
            <tr>
              <td style={styles.td}>
                <strong>Total Quantity:</strong> {totals.totalQty}
              </td>
              <td style={styles.td}>
                <strong>Total Estimated Value:</strong> ₹
                {totals.totalValue}
              </td>
            </tr>
          </tbody>
        </table>

        {/* Terms */}
        <div style={styles.sectionTitle}>Terms & Conditions</div>
        <ul>
          <li>This tender is subject to company procurement policies.</li>
          <li>Submission after closing date will not be accepted.</li>
          <li>Prices are indicative and subject to final negotiation.</li>
        </ul>

        {/* Signature */}
        <div style={{ textAlign: "right", marginTop: "40px" }}>
          <p>
            For <strong>{data.customerName || "Buyer"}</strong>
          </p>
          <br />
          <p>Authorized Signatory</p>
        </div>
      </div>
    </div>
  );
});

export default TenderPrint;
